module.exports = __webpack_public_path__ + "static/media/paypal.0d16bb13.png";